/* jshint esnext:true */
import {jQuery as $} from 'mk/jQuery';

var url = '/anltx/store-browser-event/';

export function storeEvent(name, props) {
    props = props || {};
    var data = Object.assign({}, props);
    data.__name__ = name;
    return $.post(url, data);
}

export function storeLink(selector, name, propsOrFun) {
    propsOrFun = propsOrFun || {};

    var fun = null;

    if ((typeof propsOrFun) !== 'function') {
        fun = function(node) {
            return propsOrFun;
        };
    } else {
        fun = propsOrFun;
    }

    $(selector).on('click', function(e) {
        e.preventDefault();
        var node = this;
        var data = fun(node);
        storeEvent(name, data);
        window.setTimeout(function() {
            document.location.href = node.href;
        }, 100);
    });
}

export function initBrowser() {
    const SELECTOR = 'a[data-store-click]';

    function parse($element) {
        let name = $element.data('storeClick');
        let data = {};

        let elementData = $element.data();

        // [data-store-click-props]
        if (elementData.storeClickProps) {
            data = elementData.storeClickProps;
        } else {
            // [data-store-click-prop-*]
            let key;
            for (key in elementData) {
                if (elementData.hasOwnProperty(key) && /^storeClickProp/.test(key)) {
                    let snakeCase = key.substr(14)
                        .replace(/([A-Z])/g, match => '_' + match.toLowerCase())
                        .replace(/^_/, '');
                    data[snakeCase] = elementData[key];
                }
            }
        }

        return { name, data };
    }

    function openNewWindow(e) {
        // button === 1 -> middle button
        // meta, ctrl -> new background tab
        // shift -> new window
        return e.button === 1 || e.metaKey || e.ctrlKey || e.shiftKey;
    }

    // Middle button click (alias - open in new window)
    $(document).on('click auxclick', function(e) {
        if (openNewWindow(e)) {
            let target = $(e.target);
            let element = target.is(SELECTOR) ? target : target.closest(SELECTOR);
            if (element.length) {
                let { name, data } = parse(element);
                storeEvent(name, data);
            }
        }
    });

    // Handle normal clicks
    $(document).on('click auxclick', SELECTOR, function(e) {
        if (openNewWindow(e)) {
            // This case should be handled by previous handler
            return;
        }

        e.preventDefault();

        let element = $(this);
        let { name, data } = parse(element);
        storeEvent(name, data);
        window.setTimeout(function() {
            document.location.href = element.attr('href');
        }, 100);
    });
}
